let moment = require('moment');
export const goToFirstError = function (className = 'error-check') {
    const error = document.getElementsByClassName(className);

    for (let i in error) {
        if (error[i].style && error[i].style.display !== 'none') {
            if ($(error[i]).parent().length) {
                $('html, body').animate({
                    scrollTop: $(error[i]).parent().offset().top - 75
                }, 750);
            }
            break;
        }
    }
}

export const noForeignCharacters = function (val) {
    const re = /^[\x00-\x7F]+$/;
    if (val) {
        val = val.toString();
        return re.test(val.toLowerCase());
    } else {
        return true;
    }
}

export let spinOpts = {
    lines: 7 // The number of lines to draw
    , length: 17 // The length of each line
    , width: 6 // The line thickness
    , radius: 15 // The radius of the inner circle
    , scale: 0.2 // Scales overall size of the spinner
    , corners: 1 // Corner roundness (0..1)
    , color: '#0071bc' // #rgb or #rrggbb or array of colors
    , opacity: 0.75 // Opacity of the lines
    , rotate: 0 // The rotation offset
    , direction: 1 // 1: clockwise, -1: counterclockwise
    , speed: 1.4 // Rounds per second
    , trail: 60 // Afterglow percentage
    , fps: 20 // Frames per second when using setTimeout() as a fallback for CSS
    , zIndex: 2e9 // The z-index (defaults to 2000000000)
    , className: 'spinner' // The CSS class to assign to the spinner
    , top: '50%' // Top position relative to parent
    , left: '50%' // Left position relative to parent
    , shadow: false // Whether to render a shadow
    , hwaccel: true // Whether to use hardware acceleration
    , position: 'absolute' // Element positioning
};

/**
 * isUserLoggedIn is an object with
 * isLoggedIn: Boolean
 * userDetails: Object
 */
export const isUserLoggedIn = window.immiObj.ath;

export const handleCopyCut = function (e) {
    // Disable copy/cut except for clipboard js buttons        
    const noCopyMessage = `The copy and cut function is disabled.\n immihelp.com is copyright 1999-${new Date().getFullYear()}`;
    if ($(e.target)[0].nodeName !== 'TEXTAREA') {
        if (typeof alert === 'function') {
            // Try to solve Firefox NS_ERROR_UNEXPECTED issue
            try {
                alert(noCopyMessage);
            } catch (e) {}
        }
        e.preventDefault();
        return false;
    }
};

export const getItemSessionStorage = function (key) {
    try {
        if (window.sessionStorage[key] !== undefined) {
            return window.sessionStorage.getItem(key);
        } else {
            return undefined;
        }
    } catch (e) {
        return undefined;
    }
}


export const setItemSessionStorage = function (key, value) {
    try {
        if (value) {
            window.sessionStorage.setItem(key, value);
        }
    } catch (e) {
        console.log("Session Storage is not enabled.");
    }
}

export const deleteSessionStore = function (key) {
    try {
        if(key) {
            window.sessionStorage.removeItem(key);
        }
    } catch (e) {

    }
}

/**
 * scrollToBlock gets a element and scrolls the screen to that element
 * @param {string} blockElm it can be a id like #elmId or a classname like .cssclass 
 */
export const scrollToBlock = function (blockElm) {
    const $blckElm = $(blockElm);
    if ($blckElm && $blckElm.length) {
        $('html, body').animate({
            scrollTop: $(blockElm).offset().top - 75
        }, 750);
    }
}

/**
 * @param {number} min Random number starts from
 * @param {number} max Random number ends at
 * 
 * Returns one number  between min and max
 */
export const getRandomInt = function (min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const dateNotInFutureSingleDate = function (val) {
    if (val) {
        let valSplit = '';
        let valCrt = val;
        switch (immiLang?.currentLangCode) {
            case 'zh':
                valSplit = val.split('-');
                valCrt = `${valSplit[1]}/${valSplit[2]}/${valSplit[0]}`;
                break;
            case 'es':
                valSplit = val.split('/');
                valCrt = `${valSplit[1]}/${valSplit[0]}/${valSplit[2]}`;
                break;
            default:
                valCrt = val;
                break;
        }
        
        if (val) {
            let dateToCheck1 = moment(new Date(valCrt));
            let today = moment(new Date());

            return !moment(dateToCheck1).isAfter(today);
        } else {
            return false;
        }
    } else {
        return true;
    }
}

export const convertoEnDate = function (dateVal) {
    if (!dateVal) return '';
    let valSplit = '';
    let valCrt = dateVal;
    switch (immiLang?.currentLangCode) {
        case 'zh':
            valSplit = dateVal.split('-');
            valCrt = `${valSplit[1]}/${valSplit[2]}/${valSplit[0]}`;
            break;
        case 'es':
            valSplit = dateVal.split('/');
            valCrt = `${valSplit[1]}/${valSplit[0]}/${valSplit[2]}`;
            break;
        default:
            valCrt = dateVal;
            break;
    }

    return valCrt;
}

export const convertToCurrLang = function (dateVal) {
    if (!dateVal) return '';
    let val = dateVal;
    switch (immiLang?.currentLangCode) {
        case 'zh':
            val = moment(dateVal, 'MM/DD/YYYY').format('YYYY-MM-DD');
            break;
        case 'es':
            val = moment(dateVal, 'MM/DD/YYYY').format('DD/MM/YYYY');
            break;
        default:
            val = dateVal;
            break;
    }
    return val;
}

export const dateNotInPastSingleDate = function (val) {
    if (val) {
        if (val) {
            let dateToCheck1 = new Date(convertoEnDate(val));
            let today = new Date();

            return today.setHours(0, 0, 0, 0) <= dateToCheck1.setHours(0, 0, 0, 0);
        } else {
            return false;
        }
    } else {
        return true;
    }
}

export const singleDateValidation = function (val) {
    let regx = (immiLang.currentLangCode == 'es' || immiLang.currentLangCode == 'en') ? /^\d{2}\/\d{2}\/\d{4}$/g : /^\d{4}\-\d{2}\-\d{2}$/;
    const dateFormat = immiLang?.currentLangCode == 'es' ? 'DD/MM/YYYY' : immiLang?.currentLangCode == 'zh' ? 'YYYY-MM-DD' : 'MM/DD/YYYY';
    if (val) {
        if (regx.test(val)) {
            const startDate = moment(val, dateFormat);
            const isValidDate = startDate._isValid;
            return isValidDate;
        } else {
            return false;
        }
    } else {
        return true;
    }
}


export const atleastOneNumber = function (number) {
    if (number) {
        const regex = /.*[0-9].*/;
        return regex.test(number);
    }
    return true;
}

export const hex_to_ascii = function (str1) {
    let hex = str1.toString();
    let str = '';
    for (let n = 0; n < hex.length; n += 2) {
        str += String.fromCharCode(parseInt(hex.substr(n, 2), 16));
    }
    return str;
}

export const monthList = ['January','February','March','April','May','June','July','August','September','October','November','December'];
export const monthListShr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const getParameterByName = function (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export const allowOnlyNumbers = function (evt) {
    evt = evt ? evt : window.event;
    if (evt) {
        const charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57 || charCode === 189 || charCode === 109)) && charCode !== 46) {
            evt.preventDefault();
            return true
        } else {
            return false;
        }
    }
}

export const allowOnlyLetters = function (evt) {
    evt = evt ? evt : window.event;
    if (evt) {
        const charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode === 32) {
            return false;
        } else {
            evt.preventDefault();
            return true;
        }
    }
}

export const dateTimeValidation = function (val) {
    const regx = /^\d{2}\/\d{2}\/\d{4}\s\d{2}:\d{2}\s(AM|PM)\s\w{2,3}$/g
    if (val) {
        if (regx.test(val)) {
            const startDate = moment(val, 'MM/DD/YYYY')
            const isValidDate = startDate._isValid;
            return isValidDate;
        } else {
            return false;
        }
    } else {
        return true;
    }
}

/**
 * Date String with from and to together validation
 * @param {String} val MM/DD/YYYY to MM/DD/YYYY
 */
export const dateFromToValidation = function (val) {
    const regx = /^\d{2}\/\d{2}\/\d{4}\sto\s\d{2}\/\d{2}\/\d{4}$/g
    if (val) {
        if (regx.test(val)) {
            const startDate = moment(val, 'MM/DD/YYYY')
            const isValidDate = startDate._isValid;
            return isValidDate;
        } else {
            return false;
        }
    } else {
        return true;
    }
}

export const ipAddressValidation = function (val) {
    const regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/g;
    if (val) {
        if (!regex.test(val)) {
            return false;
        }
    }
    return true;
}

export const dateDiff = function (startdate, enddate) {
    //define moments for the startdate and enddate
    let startdateMoment = moment(startdate);
    let enddateMoment = moment(enddate);
    enddateMoment.add(1, 'day');
    if (startdateMoment.isValid() === true && enddateMoment.isValid() === true) {
        //getting the difference in years
        let years = enddateMoment.diff(startdateMoment, 'years');

        //moment returns the total months between the two dates, subtracting the years
        let months = enddateMoment.diff(startdateMoment, 'months') - (years * 12);

        //to calculate the days, first get the previous month and then subtract it
        startdateMoment.add(years, 'years').add(months, 'months');
        let days = enddateMoment.diff(startdateMoment, 'days')

        return {
            years: years,
            months: months,
            days: days
        };

    } else {
        return {
            years: 0,
            months: 0,
            days: 0
        };
    }
}

const censorWordList = ["wasapp", "whatsap", "whatapp", "watsap", "watsapp", "text me", "boundless","facebook","whatsapp","trackitt","am22tech","visitorscoverage","lawbench","trusivsa","path2usa","g1g","immigrationportal","{ilw}","sheela","murthy","murthyforum","shusterman","coverance","indnet","{inf}","worldtravelcenter","veena_swsh@yahoo.co.in","{arun","vakil}","garamchai","trackins","cptracker","imminfo","immiseek","insurancepaylite","kvrao","{kvrao.org}","{health.indianetwork.org}","{health.indnet.org}","trackitt","immigrationvoice","wikipedia","visajourney","vashikaran","tantra","mantra","astro","oger","baba","magic","kitchen","fake","{hajisultan111}","{vashikaranlovespecialistuk}","{hajisultan}","{krshastri5}","{amarnathtantrik21}","{panditvishwanath}","{molviji1}","{worldfamousvashikaranguru}","541520157","{maakalijyotish}","{deendayal4826}","{panditdeendayal}","987739625{worldfamousastrology}","{blackmagics}","{vashikarnspecialist}","{allvashikaranspecialist}","{lovemarriagespecialists}","{jagannath}","{tantrik}","{jagannathtantrik21}","{babarghunat666@gmail.com}","{rghunat666}","{no1shambhunath}","{vash!karan}","{panditsharmaanant@gmail.com}","{williamsjohnson002@hotmail.com}","{loknathjimaharaj@gmail.com}","{teksonit@gmail.com}","{biginfosyss@gmail.com}","{Focustrainigs@gmail.com}","{paulhooverproduction@gmail.com}","{biginfosys.com}","{http://www.teksonit.com}","{http://www.sapboonline.com}","{etl-testing-online-training.com}","{teksonit@gmail.com}","{biginfosyss@gmail.com}","{Focustrainigs@gmail.com}","{paulhooverproduction@gmail.com}","{biginfosys.com}","{http://www.teksonit.com}","{http://www.sapboonline.com}","{etl-testing-online-training.com}","{Contact@123trainings.com}","{Contact@Sunitlabs.com}","{doctorpaul18@gmail.com}","{http://sunitlabs.com/cognos-online-training/}","{http://123trainings.com/it-android-online-training.html}","{doctorepaul.moore}","{BIG","INFOSYS}","{isaacrobinsonloanlink007@gmail.com}","{Biginfosys}","{TEKSON}","fifa1314","{hadoop-online-training}","{Dressbraw.co.uk}","{http://www.informatica-online-training.com/}","{http://www.sap-bpc-online-training.com/}","{Fifa}","{MOLVI","RAHMAN","ALI}","{VISVANATH","AGHORI}","{informatic-online-training}","AGHORI","VISVANATH","dfgdfg","Msbi","millerp","saimolvi","MOLVI","premshastri","SDHDkOGL9hIinformatica","cognos","{Kala","Jadoo}","authenticdocumentationltd","bestdocument","kellypink30","loveproblemsolution91-7726060256","118349757404560040064","loveproblemsolution","loveguru","bangalib03","Escorts","VAshiKARn","samasya","jadu-tona","new15post","perula0","7726060256","07738631006","9928926628","588-4406","InTeRCaSt","09167673311","9928926628","voodooloveexpert","rimpimalhotra8","sonalmalik","9988310846","lmkha92@gmail.com","khale_sellcvv","653661081","ESCORTS","9654122746","9672416072","Kundli","Matchmaking","jadoo","664255312","08689885909","675982025","9987582997","CVV","chi.dealers@gmail.com","cristian.leeship@gmail.com","cristian.leeship@yahoo.com.vn","jerina1.podbean.com","jerina.over-blog.com","jerina.beep.com","taniyarai.callgirlfiles.com","7726060256","9871484238","8591484546","8890900967","9958091843","typo3.org","Atom.hackers","indianfamous","651964886","jaadu","Voodoo","indianfamousmarriagesolution","9780225275","Wg7UkpHjrB","08695522223","selldumps_us","selldumps_us@yahoo.com","mikebarwisjr","tonkin@visavietnam.pro","selldumps","visatonkin","DwarkaVIP","8802779113","08800514378","likenew1977","666864110","newlike1977","sunitlabs","sap-sd-online-training","9391855249","9052820000","puredocuments","8527033546","9052820000","callgirlspaharganj","9990277699","9052820000","9391855249","sunitlabs","123trainings","123onlineclasses","it-sap-apo-online-training","7667669770","8527033546","9815884889","09004554577","09769390358","optimalstackfacts","xanogen","9780225275","07738046711","09004554577","09892124323","9929942354","9166736058","2105037100","09769390358","khanhumema319@yahoo.com","steves_jobs@yahoo.fr","verifiedhacker50@gmail.com","dorisdocumentation1@gmail.com","easyvisaa@yahoo.de","09899730334","919711170411","09004554577","09167723939","12105037100","09000249678","09887251428","x4facts.com","darkhoe007@gmail.com","9892124323","Archeage","themaya1981@hotmail.com","7204633800","07738046711","09769390358","09988279155","27717955374","lifeinuktests","720-463-3800","07738046711","09769390358","09988279155","+27717955374","-09911750765","+1","720-463-3800","09911750765","09999916529","9975114605","www.lifeinuktests.co.uk","www.skydivetulsa.com","abinitio-online-training.html","987739625","541520157","2796053907","1900129549","+91-9958802839","1900486849","60-165893786","+917073085665","+91-8890885680","1473277057","07838355623","1900-129-549","1534584698","+91-8527033546","971569758116","Numerology"];
export const censorshipStr = function (strg) {
    let newStr = strg;
    // for (let i = 0; i < censorWordList.length; i++) {    
    //     let element = censorWordList[i];
    //     element = element.replace(/\+/g,"\\+");
    //     if(element.indexOf("{") == 0) {
    //         // if { then exact word match
    //         let newElm = element.substr(1,element.length-2);
    //         let regex = new RegExp('\\b('+newElm+')\\b', 'g');
    //         newStr = newStr.replace(regex, "****");
    //     } else {
    //     	// if the word contains          
    //       let regex = new RegExp('('+element+')', 'g');
    //       newStr = newStr.replace(regex, "****");
    //     }
    // }

    return newStr;
}

/**
 * 
 * @param {String} text 
 */
export const fallbackCopyTextToClipboard = function (text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
}

function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(function() {
        console.log('Async: Copying to clipboard was successful!');
    }, function(err) {
        console.error('Async: Could not copy text: ', err);
    });
}

/**
 * @param {Array} arr | complete array ['a', 'b', 'c']
 * @param {Number} fromIndex | index of the element tobe moved from
 * @param {Number} toIndex | index of the element tobe moved to
 */
export const arrayMove = function (arr, fromIndex, toIndex) {
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
    return arr;
}

export const mustBeChecked = function (val) {
    return val === true;
}

export const onlyAlphaNumeric = function (val) {
    var re = /^[\x00-\x7F]+$/;
    if(val && typeof val === 'string'){
        return re.test(val.toLowerCase());
    }
    else{
        return true;
    }
}

export const onlyWholeNumTo100 = function (number) {
    const regex = /^[0-9][0-9]?$|^100$/;
    return regex.test(number);
}

export const generateColors = function (leng) {
    var pool = [];
    for(let i = 0; i < leng; i++) {
        pool.push(dynamicColors());
    }
    return pool;
}

function dynamicColors() {
    var r = Math.floor(Math.random() * 255);
    var g = Math.floor(Math.random() * 255);
    var b = Math.floor(Math.random() * 255);
    return "rgba(" + r + "," + g + "," + b + ", 0.5)";
}